import React from 'react';
import { Box, Grid, Button } from 'components/mui';
import { AddIcon, RemoveIcon } from 'components/icons';
import useAddressManagement from './useAddressManagement';
import LoadingBackdrop from 'components/LoadingBackdrop';
import {
  CustomerSelector,
  AddressSearch,
  AddressList,
  AddressFormUnified,
} from 'containers/pages/addressManagement/components';

function AddressManagement() {
  const { state, handler } = useAddressManagement();

  return (
    <Box
      component="main"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: { xs: 2, sm: 3 },
      }}
    >
      {/* Customer Selector + Header row wrapper */}
      <Box sx={{ width: { xs: '100%', md: '35%' }, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {/* Customer Selector */}
        <CustomerSelector
          value={state.selectedCustomer}
          customers={state.customerOptions}
          onChange={handler.onCustomerChange}
        />

        {/* Header row */}
        <Grid
          container
          alignItems="stretch"
          spacing={2}
          wrap="nowrap"
        >
          {/* Left: New Address button */}
          <Grid item>
            <Button
              variant="contained"
              startIcon={state.isOpenForm ? <RemoveIcon /> : <AddIcon />}
              onClick={handler.onToggleForm}
              disabled={!state.selectedCustomer}
              sx={{
                display: 'flex',
                alignItems: 'center',
                px: 2,
                height: '100%',
                whiteSpace: 'nowrap',
              }}
            >
              <Box sx={{ display: { xs: 'none', sm: 'inline' } }}>NEW ADDRESS</Box>
              <Box sx={{ display: { xs: 'inline', sm: 'none' } }}>NEW</Box>
            </Button>
          </Grid>

          {/* Right: Search */}
          <Grid item xs>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                height: '100%',
              }}
            >
              <AddressSearch
                searchInput={state.searchInput}
                onSearchInput={handler.onSearchInput}
                onReset={handler.onResetSearch}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* Conditional add form */}
      {state.isOpenForm && state.selectedCustomer && (
        <AddressFormUnified
          mode="add"
          customerId={state.selectedCustomer.Id}
          addressTypes={state.addressTypes}
          onSave={handler.onSaveAddress}
        />
      )}

      {/* Main address list */}
      <AddressList
        addresses={state.searchedAddresses}
        addressTypes={state.addressTypes}
        customerId={state.selectedCustomer?.Id ?? 0}
        hasCustomer={!!state.selectedCustomer}
        onSave={handler.onSaveAddress}
      />

      <LoadingBackdrop open={state.isLoading} />
    </Box>
  );
}

export default AddressManagement;
